/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

import { ClientDocumentType } from '@core/enums';
import { ClientDocument } from '@core/models';
import { Client } from '@truckstop-tms/zuum-lib';

export const loadDocuments = createAction('[ClientDetails:Documents] Load Documents', props<{ clientId: number }>());
export const loadDocumentsSuccess = createAction(
  '[ClientDetails:Documents] Load Documents Success',
  props<{ documents: ClientDocument[] }>()
);
export const loadDcoumentsFailure = createAction(
  '[ClientDetails:Documents] Load Documents Failure',
  props<{ errorMessage: string }>()
);

export const uploadDocument = createAction(
  '[ClientDetails:Documents] Upload Document',
  props<{ file: File; documentType: ClientDocumentType; client: Client }>()
);
export const uploadDocumentSuccess = createAction(
  '[ClientDetails:Documents] Upload Document Success',
  props<{ document: ClientDocument }>()
);
export const uploadDocumentFailure = createAction(
  '[ClientDetails:Documents] Upload Document Failure',
  props<{ errorMessage: string }>()
);

export const deleteDocument = createAction(
  '[ClientDetails:Documents] Delete Document',
  props<{ document: ClientDocument }>()
);
export const deleteDocumentSuccess = createAction(
  '[ClientDetails:Documents] Delete Document Success',
  props<{ documentId: number }>()
);
export const deleteDocumentFailure = createAction(
  '[ClientDetails:Documents] Delete Document Failure',
  props<{ errorMessage: string }>()
);

export const sendAsEmail = createAction(
  '[ClientDetails:Documents] Send As Email',
  props<{ document: ClientDocument; email: string }>()
);

export const shareWithClient = createAction(
  '[ClientDetails:Documents] Share With Client',
  props<{ document: ClientDocument; shareWithClient: boolean }>()
);

export const shareWithClientSuccess = createAction(
  '[ClientDetails:Documents] Share With Client Success',
  props<{ document: ClientDocument }>()
);

export const shareWithClientFailure = createAction(
  '[ClientDetails:Documents] Share With Client Failure',
  props<{ errorMessage: string }>()
);
